import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Value of Change by Functional Area',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Value of Change',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'High',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Build / Functional',
                                  y: {
                                    '#': {
                                      '@': 'highBuildFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'highChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Integration',
                                  y: {
                                    '#': {
                                      '@': 'highDataIntegration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Migration',
                                  y: {
                                    '#': {
                                      '@': 'highDataMigration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Marketing Cloud',
                                  y: {
                                    '#': {
                                      '@': 'highMarketingCloud',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Project Management',
                                  y: {
                                    '#': {
                                      '@': 'highProjectManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting & Analytics',
                                  y: {
                                    '#': {
                                      '@': 'highReportingAndAnalytics',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'highTechnical',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Medium',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Build / Functional',
                                  y: {
                                    '#': {
                                      '@': 'mediumBuildFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'mediumChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Integration',
                                  y: {
                                    '#': {
                                      '@': 'mediumDataIntegration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Migration',
                                  y: {
                                    '#': {
                                      '@': 'mediumDataMigration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Marketing Cloud',
                                  y: {
                                    '#': {
                                      '@': 'mediumMarketingCloud',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Project Management',
                                  y: {
                                    '#': {
                                      '@': 'mediumProjectManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting & Analytics',
                                  y: {
                                    '#': {
                                      '@': 'mediumReportingAndAnalytics',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'mediumTechnical',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Low',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Build / Functional',
                                  y: {
                                    '#': {
                                      '@': 'lowBuildFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'lowChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Integration',
                                  y: {
                                    '#': {
                                      '@': 'lowDataIntegration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Migration',
                                  y: {
                                    '#': {
                                      '@': 'lowDataMigration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Marketing Cloud',
                                  y: {
                                    '#': {
                                      '@': 'lowMarketingCloud',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Project Management',
                                  y: {
                                    '#': {
                                      '@': 'lowProjectManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting & Analytics',
                                  y: {
                                    '#': {
                                      '@': 'lowReportingAndAnalytics',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'lowTechnical',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Functional Area',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar.stacked',
        },
      },
    },
  },
  subqueries: {
    lowTechnical: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highTechnical: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumTechnical: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowDataMigration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highDataMigration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowMarketingCloud: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highMarketingCloud: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowBuildFunctional: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowDataIntegration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highBuildFunctional: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highDataIntegration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowChangeManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumDataMigration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highChangeManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowProjectManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumMarketingCloud: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highProjectManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumBuildFunctional: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumDataIntegration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumChangeManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumProjectManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowReportingAndAnalytics: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highReportingAndAnalytics: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumReportingAndAnalytics: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!value_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
